import { createAction } from '@poa/state';

// fetching
export const fetch = createAction('calendar/fetchCalendar', () => ({}));
export const fetchSuccess = createAction('calendar/fetchSuccess', data => ({
  data
}));
export const fetchFailed = createAction('calendar/fetchFailed', () => ({}));

// filters
// grouping
export const changeGrouping = createAction('calendar/changeReportsGrouping', grouping => ({
  grouping
}));
export const resetGrouping = createAction('calendar/resetReportsGrouping', grouping => ({
  grouping
}));

// status
export const changeStatus = createAction('calendar/changeReportsStatus', status => ({ status }));
export const resetStatuses = createAction('calendar/resetReportsStatuses', statuses => ({
  statuses
}));

// dates
export const setDates = createAction(
  'calendar/setDates',
  (startDate, endDate, shouldFetch = true) => ({
    startDate,
    endDate,
    shouldFetch
  })
);
